<template>
  <div class="main-container11">
    <div class="sub-header fixed" style="position: fixed; top: 0">
      <div class="left-back" style="line-height: 68px; padding-left: 12px">
        <img
          src="@/assets/boyuan_72.png"
          style="height: 46px; line-height: 60px; vertical-align: middle"
        />
        <span style="padding-left: 5px">考试成绩</span>
      </div>
      <div class="right-title">
        <span>{{ this.examPlanInfo.planName }}</span>
      </div>
    </div>
    <div
      class="main-con"
      style="
        margin-top: 68px;
        display: flex;
        flex-direction: column;
        background-color: #efefef;
      "
    >
      <div class="left-menu" style="position: fixed">
        <div class="catalog-con">
          <div class="inner">
            <p class="title"><strong>答题卡</strong></p>
            <div class="item-box">
              <div
                v-for="(paper, index) in testingPaperData"
                :key="index"
                class="item"
              >
                <div class="section">
                  <p class="sec_name">{{ paper.name }}</p>
                </div>
                <ul style="display: flex; flex-wrap: wrap">
                  <li
                    v-for="child in paper.children"
                    :key="child.id"
                    :class="{
                      answered: child.state === 1,
                      wrong: child.state === 2,
                    }"
                  >
                    <a @click="selectQuestion(child.id)">
                      <div class="articleName">{{ child.serialNumber }}</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="bottom">
              <p
                style="
                  border: 1px solid rgba(28, 31, 33, 0.1);
                  background: #409eff;
                  width: 15px;
                  height: 10px;
                  margin: 0 5px;
                "
              />
              正确
              <p
                style="
                  border: 1px solid rgba(28, 31, 33, 0.1);
                  background: #ff0000;
                  width: 15px;
                  height: 10px;
                  margin: 0 5px;
                "
              />
              错误
              <!-- <p
                style="
                  border: 1px solid rgba(28, 31, 33, 0.1);
                  background: #efefef;
                  width: 15px;
                  height: 10px;
                  margin: 0 5px;
                "
              />
              未答 -->
            </div>
          </div>
        </div>
      </div>
      <div class="right-content">
        <div class="container" style="max-width: 1200px; min-width: 800px">
          <div class="center_con" style="margin-top: 45px">
            <div class="article-con">
              <!-- 试题 -->
              <questions
                ref="questionsChild"
                :questions-data="testingQuestionsData"
                :zoom="zoom"
                :onlyWrong="onlyWrong"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="right-toolbar">
        <div
          style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          "
        >
          <span>考生姓名</span>
          <p style="color: #3a8ee6">{{ studentInfo.fullName }}</p>
        </div>
        <div
          style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          "
        >
          <span>考生班级</span>
          <p style="color: #3a8ee6">
            {{ this.$store.getters["user/classesName"] }}
          </p>
        </div>
        <div
          style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          "
        >
          <span>考试成绩</span>
          <p style="color: #3a8ee6">
            {{ achievementInfo.totalScore }}
          </p>
        </div>
        <div
          style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          "
        >
          <span>班级排名</span>
          <p style="color: #3a8ee6">
            {{
              achievementInfo.classesRanking === null
                ? "-"
                : achievementInfo.classesRanking
            }}
          </p>
        </div>
        <div
          style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          "
        >
          <span>总排名</span>
          <p style="color: #3a8ee6">
            {{
              achievementInfo.companyRanking === null
                ? "-"
                : achievementInfo.companyRanking
            }}
          </p>
        </div>
        <div
          style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          "
        >
          <span>状态</span>
          <p style="color: #3a8ee6">
            {{
              achievementInfo.examState === null
                ? "-"
                : achievementInfo.examState === 1
                ? "参考"
                : "缺考"
            }}
          </p>
        </div>
        <div
          style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          "
        >
          <span>仅看错题</span>
          <div>
            <el-switch v-model="onlyWrong" active-color="#ff4949" />
          </div>
        </div>
        <div
          style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          "
        >
          <span>调整字体大小</span>
          <el-button-group>
            <el-button type="primary" size="mini" @click="toZoom('-')"
              >-</el-button
            >
            <el-button size="mini" style="padding: 7px">
              {{ `${this.zoom}%` }}
            </el-button>
            <el-button type="primary" size="mini" @click="toZoom('+')"
              >+</el-button
            >
          </el-button-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { examAchievementService, examPlanService } from "@/api/exams";
import { usersService } from "@/api/users";
import Questions from "./components/Questions";

export default {
  name: "Results",
  components: { Questions },
  data() {
    return {
      achievementInfo: {
        id: undefined,
        totalScore: undefined,
        classesRanking: undefined,
        companyRanking: undefined,
        examState: undefined,
      },

      studentInfo: {},

      examPlanInfo: {
        planId: undefined,
        planName: undefined,
        paperId: undefined,
        paperName: undefined,
      },

      // 考试试卷对象
      testingPaperData: [
        {
          name: "单选题",
          score: "",
          halfScore: "",
          questionType: 1,
          children: [],
        },
        {
          name: "多选题",
          score: "",
          halfScore: "",
          questionType: 2,
          children: [],
        },
        {
          name: "判断题",
          score: "",
          halfScore: "",
          questionType: 3,
          children: [],
        },
      ],
      testingQuestionsData: [],
      zoom: 0, //
      onlyWrong: false, //仅错题
    };
  },
  created() {
    const id = this.$route.params && this.$route.params.id;
    this.getAchievement(id);
  },
  methods: {
    // 获取评卷
    getAchievement(achievementId) {
      const loading = this.$loading({
        lock: true,
        text: "考卷加载中",
        spinner: "el-icon-loading",
      });

      examAchievementService
        .getAchievementById(achievementId)
        .then((achievement) => {
          this.achievementInfo = achievement;

          const planId = achievement.planId;
          const userId =
            achievement.userId === "00000000-0000-0000-0000-000000000000"
              ? achievement.boyuanUserId
              : achievement.userId;

          // 获取考生信息
          usersService.getUserById(userId).then((info) => {
            const data = info.data;
            this.studentInfo.fullName = data.fullName;
            this.studentInfo.classesId = data.userInfo.classesId;
          });

          // 获取学生评卷信息
          examPlanService
            .getEstimatingByStudent({
              planId,
              userId,
            })
            .then((res) => {
              this.examPlanInfo = Object.assign({
                planId: res.id,
                planName: res.name,
                paperId: res.paperId,
                paperName: res.paperName,
              });

              // 试卷数据
              this.testingPaperData.forEach((paper) => {
                const setting = res.settings.find(
                  (i) => i.questionType === paper.questionType
                );
                paper.score = setting.score;
                paper.halfScore = setting.halfScore;

                paper.children = setting.children;
              });

              const questionsData = res.questions.map((i) => {
                let options = [];
                switch (i.questionType) {
                  case 3:
                    options = [{ value: "对" }, { value: "错" }];
                    break;
                  default:
                    options = i.options.map((opt) => {
                      return {
                        value: opt,
                      };
                    });
                    break;
                }

                return Object.assign(i, { options, sysScore: i.examScore });
              });

              this.testingQuestionsData = questionsData;
              // 关闭遮罩层
              loading.close();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 选中答题卡选项
    selectQuestion(id) {
      this.$refs.questionsChild.scrollToAnchor(id);
    },
    toZoom(type) {
      switch (type) {
        case "+":
          if (this.zoom < 100) {
            this.zoom += 10;
          }
          break;
        case "-":
          if (this.zoom > 0) {
            this.zoom -= 10;
          }
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
ul,
ol,
li,
p {
  margin: 0;
  padding: 0;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 68px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  z-index: 4;
  border-top: 1px solid #f3f5f6;
  box-sizing: border-box;
  transition: top 0.3s 0.3s;
  -moz-transition: top 0.3s 0.3s;
  -webkit-transition: top 0.3s 0.3s;
  -o-transition: top 0.3s 0.3s;
}

.sub-header .fixed {
  position: fixed;
  top: 0;
}

.left-back {
  position: absolute;
  left: 0;
  top: 0;
  width: 236px;
  /* padding: 16px 20px; */
  box-sizing: border-box;
  transition: left 0.3s;
  -moz-transition: left 0.3s;
  -webkit-transition: left 0.3s;
  -o-transition: left 0.3s;
}

.left-back a.icon {
  display: inline-block;
  width: 28px;
  height: 28px;
  margin-right: 16px;
  vertical-align: middle;
}

.left-back a i {
  font-size: 28px;
  color: #9199a1;
  text-align: center;
  line-height: 28px;
}

.left-back span {
  font-size: 26px;
  color: #1c1f21;
  font-weight: 600;
  display: inline-block;
  /* height: 28px; */
  line-height: 36px;
  vertical-align: middle;
}

.right-title {
  margin-left: 236px;
  padding: 20px 24px;
  font-size: 14px;
  color: #9199a1;
  position: relative;
  padding-left: 68px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  transition: margin-left 0.3s;
  -moz-transition: margin-left 0.3s;
  -webkit-transition: margin-left 0.3s;
  -o-transition: margin-left 0.3s;
}

.right-title em {
  padding: 0 4px;
}

.right-title span {
  line-height: 28px;
  font-size: 18px;
  color: #1c1f21;
}

.main-con {
}

.main-con .left-menu {
  position: absolute;
  top: 68px;
  left: 0;
  bottom: 0;
  width: 238px;
  z-index: 3;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  /* border: 1px solid #efefef;*/
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px;
}

.left-menu .catalog-con {
  position: absolute;
  width: 238px;
  top: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  padding-top: 58px;
  padding-bottom: 58px;
  box-sizing: border-box;
}

.catalog-con .inner {
  position: relative;
  height: 100%;
  width: 100%;
}

.catalog-con .inner .title {
  position: absolute;
  top: -58px;
  left: 0;
  right: 0;
  font-size: 18px;
  color: #1c1f21;
  line-height: 25px;
  margin: 0 10px;
  padding: 16px 6px;
  border-bottom: 1px solid #f3f5f6;
}

.catalog-con .inner .bottom {
  position: absolute;
  /* top: 0; */
  left: 0;
  right: 0;
  font-size: 14px;
  color: #606266;
  line-height: 10px;
  margin: 0 10px;
  padding: 14px 20px;
  border-top: 1px solid #f3f5f6;
  display: flex;
  justify-content: flex-end;
}

.catalog-con .inner .item-box {
  padding: 5px 10px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.active-bg {
  background: #f0f8ff;
}

.item {
  padding: 10px 0;
}

.item:not(:last-child) {
  border-bottom: 1px solid #dedede;
}

.item .section {
  width: 100%;
}

// 选中
.item .active {
  // background: #c0c4cc;
  filter: drop-shadow(0px 0px 2px #409eff);
}

.item .answered {
  background: #409eff;

  ::v-deep .articleName {
    color: #fff;
  }
}

.item .wrong {
  background: #ff0000;

  ::v-deep .articleName {
    color: #fff;
  }
}

.section .sec_name {
  width: 100%;
  font-size: 15px;
  color: #1c1f21;
  line-height: 18px;
  text-align: left;
  font-weight: 700;
  padding: 10px 6px;
}

ol,
ul {
  list-style: none;
}

.item ul li {
  position: relative;
  box-sizing: border-box;
  /* padding: 8px 8px; */
  margin: 5px;
  border: 1px solid rgba(28, 31, 33, 0.1);
  background: #efefef;
  width: 30px;
  height: 20px;

  text-align: center;
  cursor: pointer;
}

.item ul li .articleName {
  max-width: 380px;
  font-size: 15px;
  color: #909399;
  line-height: 20px;
  // margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.main-con .right-content {
  padding-left: 236px;
  padding-right: 200px;
  position: relative;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

.right-content .container {
  /* width: 1000px; */
  margin: 0 auto;
  /* display: none; */
}

.right-content .container .center_con {
  /* width: 1000px; */
  margin-top: 52px;
  margin-bottom: 36px;
}

.container .center_con .article-con {
  padding: 52px 64px 68px;
  background: #fff;
  position: relative;
}

.right-toolbar {
  width: 150px;
  background: rgb(255, 255, 255);
  margin-left: 50px;
  right: 90px;
  top: 113px;
  position: fixed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.art-buy {
  position: absolute;
  left: 0;
  top: 0;
  /* width: 952px; */
  min-width: calc(100% - 48px);
  height: 132px;
  box-sizing: border-box;
  padding: 0 32px;
  padding: 0 8px;
  margin: 0 24px;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.l {
  float: left;
}

.art-buy .img {
  /* width: 96px; */
  height: 128px;
  margin-top: -20px;
  margin-right: 19px;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 4px 8px 0 rgba(28, 31, 33, 0.06),
    0 8px 16px 0 rgba(28, 31, 33, 0.06), 0 12px 24px 0 rgba(28, 31, 33, 0.06),
    0 16px 32px 0 rgba(28, 31, 33, 0.06);
  border-radius: 8px;
}

.art-buy .text {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
}

.art-buy .text .title {
  /* width: 348px; */
  font-weight: 700;
  font-size: 20px;
  color: #1c1f21;
  line-height: 22px;
  text-align: left;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.art-buy .text .price_con .price_ori {
  font-weight: 700;
  font-size: 12px;
  color: #9199a1;
  text-align: left;
  line-height: 12px;
  margin-right: 8px;
}

.article-con .art-title {
  font-size: 28px;
  color: #1c1f21;
  text-align: left;
  line-height: 36px;
  font-weight: 700;
  margin-bottom: 16px;

  margin-top: 112px;
}

.art-info {
  margin-bottom: 8px;
}

.art-info span {
  font-size: 12px;
  color: #9199a1;
  line-height: 24px;
}

.art-content {
  margin-bottom: 24px;
  line-height: 32px !important;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, STHeiti,
    "Microsoft Yahei", sans-serif;
  font-size: 16px;
  line-height: 32px;
  color: #1c1f21;
  word-wrap: break-word;
}

@media only screen and (max-width: 1800px) {
  .right-toolbar {
    right: 1px;
  }
}

@media only screen and (max-width: 1300px) {
  .center_con {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .right-toolbar {
    top: 69px;
  }

  .article-con {
    // padding-left: 15px !important;
    // padding-right: 15px !important;
    // padding-top: 10px !important;
    padding: 10px 15px !important;
  }
}
</style>
